import { render, staticRenderFns } from "./PlateNotFound.vue?vue&type=template&id=4611654c&"
import script from "./PlateNotFound.vue?vue&type=script&lang=js&"
export * from "./PlateNotFound.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports